'use strict';

import {contractModel} from "../../models/contractmodel.js";

export class ContractPreambleCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new contractModel(jsDataService.get('item', {}), $filter, jsDataService);
		this.initFields();
	}
	
	initFields(){
		this.item.annex_3_on = (typeof(this.item.annex_3_on) !== 'undefined' && (this.item.annex_3_on === 1 || this.item.annex_3_on === '1' || true === this.item.annex_3_on));
		this.item.annex_4_on = (typeof(this.item.annex_4_on) !== 'undefined' && (this.item.annex_4_on === 1 || this.item.annex_4_on === '1' || true === this.item.annex_4_on));
		this.item.annex_1_on = true;
		this.item.annex_2_on = true;
		this.item.terms_conditions = true;
		this.item.data_sheet = true;
		this.item.preamble = true;
	}
	
	autosavePostFields(){
		return {
			item: {
				annex_3_on: this.item.annex_3_on,
				annex_4_on: this.item.annex_4_on
			}
		};
	}

	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}